/* ============================================================
   new-nav.js — Scrollable Navigation Bar Logic | Amazon
   ============================================================ */

(function () {
  function initnewNav() {
    const view    = document.querySelector('.new-view');
    const list    = document.querySelector('.new-list');
    const btnPrev = document.querySelector('.new-prev');
    const btnNext = document.querySelector('.new-next');
    const isRTL   = document.querySelector('.new-wrapper').getAttribute('dir') === 'rtl';

    if (!view || !list) return;

    let currentPos = 0;

    const updateArrows = () => {
      const maxMove = list.scrollWidth - view.clientWidth;

      if (list.scrollWidth > view.clientWidth) {
        btnPrev.style.display = currentPos < 0 ? 'flex' : 'none';
        btnNext.style.display = Math.abs(currentPos) < maxMove - 5 ? 'flex' : 'none';
      } else {
        btnPrev.style.display = 'none';
        btnNext.style.display = 'none';
      }
    };

    const move = (direction) => {
      const step    = 250;
      const maxMove = list.scrollWidth - view.clientWidth;

      if (direction === 'next') currentPos -= step;
      else currentPos += step;

      if (currentPos > 0) currentPos = 0;
      if (Math.abs(currentPos) > maxMove) currentPos = -maxMove;

      list.style.transform = `translateX(${isRTL ? -currentPos : currentPos}px)`;
      updateArrows();
    };

    btnNext.onclick = () => move('next');
    btnPrev.onclick = () => move('prev');

    window.addEventListener('resize', () => {
      currentPos = 0;
      list.style.transform = 'translateX(0px)';
      updateArrows();
    });

    updateArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initnewNav);
  } else {
    initnewNav();
  }
})();